export const roundProductRating = (rating: number) => Math.ceil(rating * 2) / 2;
